import Spyfall from "./Components/Spyfall/SpyfallRoutes";

function App() {
  // routing in App
  return <Spyfall />;
}

export default App;
